/* Displays a statistic consisting of an icon, title and value */
import { Group, Center, Text, Stack, Tooltip } from "@mantine/core";

export default function Stat(props) {
  let element;
  if (props.small) {
    element = (
      <Stack>
        <Center>{props.logo}</Center>
        <Center>{props.title}</Center>
        <Center>{props.content}</Center>
      </Stack>
    );
  } else {
    element = (
      <Group position="apart" grow>
        <Stack>
          <Center>{props.logo}</Center>
          <Center>{props.title}</Center>
        </Stack>
        <Center>{props.content}</Center>
      </Group>
    );
  }

  if (props.description) {
    return <Tooltip label={props.description}>{element}</Tooltip>;
  } else {
    return element;
  }
}
